// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: #f5f1e9;
  overflow-x: hidden;
}

#root {
  min-height: 100vh;
}

/* Контейнер приложения: футер прижат к низу при нехватке контента */
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 77px;
}

.app-main {
  flex: 1 0 auto;
}

/* Основной контейнер сайта: по центру, отступы по краям */
.page-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-left: 26px;
  padding-right: 26px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .app-layout {
    padding-top: 88px;
  }

  .page-container {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media (max-width: 430px) {
  .app-layout {
    padding-top: 92px;
  }

  .page-container {
    padding-left: 12px;
    padding-right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background-color: #f5f1e9;\n  overflow-x: hidden;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n/* Контейнер приложения: футер прижат к низу при нехватке контента */\n.app-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding-top: 77px;\n}\n\n.app-main {\n  flex: 1 0 auto;\n}\n\n/* Основной контейнер сайта: по центру, отступы по краям */\n.page-container {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding-left: 26px;\n  padding-right: 26px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .app-layout {\n    padding-top: 88px;\n  }\n\n  .page-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n@media (max-width: 430px) {\n  .app-layout {\n    padding-top: 92px;\n  }\n\n  .page-container {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
